module.exports = __webpack_public_path__ + "static/art-4-da41cad7baa59e98fadcfd9e95f6bcd3.jpg";